<template>
    <div class="flex-3 marginT-20">
        <el-form ref="form" :model="form" label-width="130px" label-position="left">
            <div class="mark-group">
                <el-form-item label="打标拼多多账号：">
                    <el-input
                        type="textarea"
                        wrap="off"
                        :rows="8"
                        v-model="user_ids"
                        placeholder="一行一个拼多多账号id，最多可以输入200个">
                    </el-input>
                </el-form-item>
                <el-form-item label="打标商品：">
                    <el-input v-model="product_ids" placeholder="请输入商品链接或者商品id">
                    </el-input>
                </el-form-item>
            </div>
            <el-form-item>
                <span class="fc-666">必须提交的是拼多多用户id号，获取用户id相关流程，<span class="point fc-theme" @click="intro">点击查看</span> </span>
                <br>
                <el-button type="danger" @click="onSubmit">提交查询</el-button>
            </el-form-item>
        </el-form>
        <intro v-if="showIntro" v-model="showIntro"></intro>
    </div>
</template>

<script>
import intro from './intro';
export default {
    components: {
        intro,
    },
    data() {
        return {
            showIntro: false,
            user_ids: undefined,
            product_ids: undefined,
            form: {
                type: 1,
                user_ids: undefined,
                product_ids: undefined
            },
        }
    },
    methods: {
        parseUid() {
            const arr = this.user_ids.split('\n')
            const result = []
            arr.forEach(item => {
                item = item.replace(/ /g, '')
                if (item && item.indexOf('http') > -1) {
                    try {
                        const url = new URL(item)
                        const accountId = this.getQueryVariable(url, 'refer_share_uid')
                        if (accountId) {
                            result.push(accountId)
                        }
                    } catch (error) {

                    }

                } else {
                    if (item) result.push(item)
                }
            })
            if (result.length > 0) {
                return result.join(',')
            } else {
                return false
            }
        },
        onSubmit() {
            window.checkDiscountPackage("pddforcescreen")
            if (!this.user_ids || !this.product_ids) {
                this.$message.error('请填写完整')
                return
            }
            this.form.user_ids = this.parseUid()
            if (!this.form.user_ids) {
                this.$message.error('未找到拼多多账号')
                return
            }
            if (this.product_ids && this.product_ids.indexOf('http') > -1) {
                if (this.product_ids.indexOf('goods_id') == -1) {
                    this.$message.error('未找到商品ID')
                    return
                }
                try {
                    const url = new URL(this.product_ids.replace(/ /g, ''))
                    const productId = this.getQueryVariable(url, 'goods_id')
                    this.form.product_ids = productId
                } catch (error) {
                    this.$message.error('未找到商品ID')
                    return
                }
            } else {
                this.form.product_ids = this.product_ids.replace(/ /g, '')
            }
            // console.log(this.form);
            this.submit()
        },
        intro() {
            if (this.isToolMainSite()) {
                window.open('http://ask.vv-tool.com/article/3306')
            } else {
                this.showIntro = true
            }
        },
        async submit() {
            const data = await this.$fetch('/api/proxy/web/pddforcescreen', this.form, 'post')
            console.log({data});
            if (data.code == 0) {
                this.$message.success('提交成功')
                this.$emit('refreshRecode')
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
